import {
  PrimaryLightTextColor,
  PrimaryTextColor,
  boldFont,
  getRelativeFontSize,
  primaryRedColor,
  regularFont,
  theme,
} from "../../../utils/styles";

const customInputStyles = {
  textField: {
    border: "none",
    width: "100%",
    "& .MuiInputBase-input": {
      color: PrimaryTextColor,
      ...regularFont,
      position: "relative",
      background: "#fff",
      height: "38px",
      padding: "0 10px",
      border: "none",
      fontSize: getRelativeFontSize(0),
      [theme.breakpoints.down("xl")]: {
        height: "38px",
      },
      "&::placeholder": {
        ...regularFont,
        fontSize: getRelativeFontSize(0),
        color: PrimaryLightTextColor,
      },
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "4px",
      "&.Mui-focused fieldset": {
        borderColor: "#E7E7EA",
      },
      "&:hover fieldset": {
        borderColor: "#E7E7EA",
      },
    },
    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
      borderColor: "#E7E7EA",
    },
    "& .MuiFormHelperText-root": {
      color: primaryRedColor,
      fontSize: getRelativeFontSize(-1),
      ...regularFont,
      marginLeft: "5px",
      marginBottom: "5px",
    },
    "& input[type='file']": {
      diaplay: "flex",
      alignItems: "center",
      padding: "5px 10px",
      height: "28px",
      fontSize: getRelativeFontSize(0),
      ...regularFont,
    },
  },
  nameField: {
    ...regularFont,
    fontSize: getRelativeFontSize(),
    marginBottom: "3px",
    wordSpacing: "2px",
    color: PrimaryTextColor,
    marginTop: "5px",
  },
  boldNameField: {
    ...regularFont,
    fontSize: "14px",
    wordSpacing: "2px",
    marginTop: "5px",
    fontWeight:"700",
    color:"#000",
    marginBottom:"5px"
  },
  commentAsterisk: {
    color: "red",
    ...regularFont,
  },
  "& .MuiFormLabel-asterisk":{
color:"red"
  },
} as const;

export default customInputStyles;
